/** Metadata keys to exclude from table display */
export const META_KEYS = [
  'diffgr:id',
  'msdata:rowOrder',
  'diffgr:hasChanges',
  'xmlns',
];

/** Seconds fields (will format as HH:MM:SS) */
export const TIME_FIELDS = [
  'Login', 'Unstaffed', 'Avail', 'Preview', 'Dial', 'Ring', 'Connect',
  'Hold', 'ACW', 'NotReady', 'Break0', 'Break1', 'Break2', 'Break3',
  'Break4', 'Break5', 'Break6', 'Break7', 'Break8', 'Break9',
  'AuxiliarTotal', 'TiempoRealLogueo', 'AvailMax', 'HoldMax',
  'NotReadyMax', 'TalkingTimeInternasEntrantes', 'TalkingTimeInternasSalientes',
];

/** Percentage fields */
export const PCT_FIELDS = [
  'AuxiliarPorciento', 'Utilizacion', 'ConnectReal', 'RingReal',
  'AvailReal', 'AHT', 'ATT', 'CEPorc', 'ExitosCE', 'ExitosHoraReal',
];

/** Extract Table1 (rows) and Table2 (labels) from Mitrol response */
export function extractMitrolData(data) {
  if (!data || !data.data) return null;
  const d = data.data;

  // Formato limpio del backend: d = { Table1: [...], Table2: [...] }
  if (d.Table1) {
    let rows = d.Table1;
    if (!Array.isArray(rows)) rows = [rows];
    const labels = d.Table2 || null;
    return { rows, labels };
  }

  // Legacy: estructura XML sin limpiar (diffgram)
  const diffgram = d['diffgr:diffgram'];
  if (!diffgram) return null;
  const ds = diffgram['NewDataSet'] || diffgram['newDataSet'];
  if (!ds) return null;
  let rows = ds['Table1'];
  if (!rows) return null;
  if (!Array.isArray(rows)) rows = [rows];
  const labels = ds['Table2'] || null;
  return { rows, labels };
}

export function formatSeconds(val) {
  const s = parseInt(val);
  if (isNaN(s) || s === 0) return '00:00:00';
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}

export function formatPct(val) {
  const n = parseFloat(val);
  if (isNaN(n)) return val;
  return (n * 100).toFixed(2) + '%';
}

export function formatDate(val) {
  if (!val || typeof val !== 'string') return val;
  try {
    const d = new Date(val);
    if (isNaN(d)) return val;
    return (
      d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
      ' ' +
      d.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })
    );
  } catch {
    return val;
  }
}

/** Convert a report.aspx URL to wsParameter format */
export function extractWsParamFromUrl(url) {
  try {
    const queryString = url.includes('?') ? url.split('?')[1] : url;
    const cleaned = queryString.replace(/&$/, '');
    const pairs = cleaned
      .split('&')
      .map((pair) => decodeURIComponent(pair.replace(/\+/g, ' ')))
      .filter((pair) => {
        const key = pair.split('=')[0];
        return key && key.trim() !== '';
      });
    return pairs.join('##') + '##';
  } catch {
    return url;
  }
}

/** Export data rows to CSV and trigger download */
export function exportCSV(rows, labels, keys) {
  const headerRow = keys
    .map((k) => '"' + ((labels && labels[k]) || k).replace(/"/g, '""') + '"')
    .join(',');
  const dataRows = rows.map((row) =>
    keys
      .map((k) => {
        let v = row[k] ?? '';
        return '"' + String(v).replace(/"/g, '""') + '"';
      })
      .join(',')
  );
  const csv = [headerRow, ...dataRows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'reporte_mitrol_' + new Date().toISOString().slice(0, 10) + '.csv';
  a.click();
  URL.revokeObjectURL(url);
}
